import React from 'react'

 import ConfirmedPharmacistsComponent from '../../../components/pharmacist/confirmedPharmacists/ConfirmedPharmacists'

function ConfirmedPharmacists() { 
  return (
    <>
    <ConfirmedPharmacistsComponent/>
    </>
  )
}

export default ConfirmedPharmacists